import React from 'react';
import PropTypes from 'prop-types';

export const IconLangKz = ({ className }) => (
  <img
    className={className}
    width="30"
    height="24"
    src="/assets/public/kk.png"
    alt="icon-lang-kk"
  />
);

IconLangKz.propTypes = {
  className: PropTypes.string,
};

IconLangKz.defaultProps = {
  className: null,
};
